module.exports = __webpack_public_path__ + "img/pic_channel.b374cbed.png";